import { render, staticRenderFns } from "./BarShutterDescription.vue?vue&type=template&id=6b48f0ad&scoped=true"
import script from "./BarShutterDescription.vue?vue&type=script&lang=ts"
export * from "./BarShutterDescription.vue?vue&type=script&lang=ts"
import style0 from "./BarShutterDescription.vue?vue&type=style&index=0&id=6b48f0ad&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b48f0ad",
  null
  
)

export default component.exports